/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_GovernmentDocumentTypeDto } from '../models/PagedResultDto_GovernmentDocumentTypeDto';
import type { Wealthlane_CustomerService_Dtos_GovernmentDocumentType_CreateUpdateGovernmentDocumentTypeDto } from '../models/Wealthlane_CustomerService_Dtos_GovernmentDocumentType_CreateUpdateGovernmentDocumentTypeDto';
import type { Wealthlane_CustomerService_Dtos_GovernmentDocumentType_GovernmentDocumentTypeDto } from '../models/Wealthlane_CustomerService_Dtos_GovernmentDocumentType_GovernmentDocumentTypeDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GovernmentDocumentTypeService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_GovernmentDocumentType_GovernmentDocumentTypeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppGovernmentDocumentTypeGovernmentDocumentTypesList(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_GovernmentDocumentType_GovernmentDocumentTypeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/government-document-type/government-document-types-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_GovernmentDocumentType_GovernmentDocumentTypeDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppGovernmentDocumentType(
        requestBody?: Wealthlane_CustomerService_Dtos_GovernmentDocumentType_CreateUpdateGovernmentDocumentTypeDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_GovernmentDocumentType_GovernmentDocumentTypeDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/government-document-type',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_GovernmentDocumentTypeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppGovernmentDocumentType(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_GovernmentDocumentTypeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/government-document-type',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_GovernmentDocumentType_GovernmentDocumentTypeDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppGovernmentDocumentType(
        id: string,
        requestBody?: Wealthlane_CustomerService_Dtos_GovernmentDocumentType_CreateUpdateGovernmentDocumentTypeDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_GovernmentDocumentType_GovernmentDocumentTypeDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/government-document-type/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppGovernmentDocumentType(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/government-document-type/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_CustomerService_Dtos_GovernmentDocumentType_GovernmentDocumentTypeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppGovernmentDocumentType1(
        id: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_GovernmentDocumentType_GovernmentDocumentTypeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/government-document-type/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
